export =
    [{
        "fill": {
			"pattern": {
				"orientation": "vertical",
				"color": "rgba(12,236,43,1)",
				"spacing": 7,
				"repitition": "repeat"
			}
		}
    }];